import(/* webpackMode: "eager" */ "/opt/thedesperatetrader/app/game/rankings/page.tsx");
